import React, { useState, useEffect } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  Box,
  Typography,
  IconButton,
  TextField,
  Button,
  Grid,
  Tooltip,
  Divider,
  Alert
} from '@mui/material';
import {
  Close as CloseIcon,
  ContentCopy as ContentCopyIcon,
  Close as XIcon,
  Facebook as FacebookIcon,
  LinkedIn as LinkedInIcon,
  Email as EmailIcon,
  Check as CheckIcon
} from '@mui/icons-material';
// import { useSurvey } from '../../contexts/SurveyContext';

const PublishModal = ({ open, onClose, surveyId, userId }) => {
  const [copied, setCopied] = useState(false);
  const [shortId, setShortId] = useState('');
  // const { setSurveyData } = useSurvey(); 

  // Generate a 6-character alphanumeric ID
  useEffect(() => {
    const generateShortId = () => {
      const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
      let result = '';
      for (let i = 0; i < 6; i++) {
        result += chars.charAt(Math.floor(Math.random() * chars.length));
      }
      return result;
    };

    // Only generate a new ID when the modal opens and we don't have one
    if (open && !shortId) {
      setShortId(generateShortId());
    }
  }, [open, shortId]);

  // Store the survey ID and user ID in sessionStorage with the short ID as the key
  // useEffect(() => {
  //   if (shortId && surveyId && userId) {
  //     // Store the mapping so SurveyForm.js can retrieve it
  //     sessionStorage.setItem(`form_${shortId}`, JSON.stringify({
  //       surveyId,
  //       userId
  //     }));
  //   }
  // }, [shortId, surveyId, userId]);
  // useEffect(() => {
  //   if (shortId && surveyId && userId) {
  //     console.log("Storing form mapping:", {
  //       shortId,
  //       surveyId,
  //       userId
  //     });

  //     const mappingData = JSON.stringify({
  //       surveyId,
  //       userId
  //     });

  //     // Store in both storage types for better persistence
  //     try {
  //       sessionStorage.setItem(`form_${shortId}`, mappingData);
  //       localStorage.setItem(`form_${shortId}`, mappingData);
  //       console.log("Mapping stored successfully");

  //       // Verify storage
  //       const sessionCheck = sessionStorage.getItem(`form_${shortId}`);
  //       const localCheck = localStorage.getItem(`form_${shortId}`);
  //       console.log("Storage verification:", {
  //         sessionStorage: sessionCheck ? "Success" : "Failed",
  //         localStorage: localCheck ? "Success" : "Failed"
  //       });
  //     } catch (error) {
  //       console.error("Error storing mapping:", error);
  //     }
  //   }
  // }, [shortId, surveyId, userId]);

  // useEffect(() => {
  //   if (open && surveyId && userId) {
  //      console.log("Setting survey data in context:", { surveyId, userId });
  //     setSurveyData({ surveyId, userId }); // Set the survey data in the context
  //   }
  // }, [open, surveyId, userId]);

  const formLink = `${window.location.origin}/app/form/${surveyId}`;
  console.log("Form link:", formLink);


  const handleCopyLink = async () => {
    try {
      await navigator.clipboard.writeText(formLink);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch (err) {
      console.error('Failed to copy:', err);
    }
  };

  const handleShare = (platform) => {
    const shareUrl = encodeURIComponent(formLink);
    const shareText = encodeURIComponent('Please fill out this form');

    switch (platform) {
      case 'twitter':
        window.open(`https://twitter.com/intent/tweet?url=${shareUrl}&text=${shareText}`);
        break;
      case 'facebook':
        window.open(`https://www.facebook.com/sharer/sharer.php?u=${shareUrl}`);
        break;
      case 'linkedin':
        window.open(`https://www.linkedin.com/sharing/share-offsite/?url=${shareUrl}`);
        break;
      case 'email':
        window.open(`mailto:?subject=Form&body=${shareText}%0A${shareUrl}`);
        break;
      default:
        break;
    }
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>
        <Box display="flex" justifyContent="space-between" alignItems="center">
          <Typography variant="h6">Your form was published</Typography>
          <IconButton onClick={onClose} size="small">
            <CloseIcon />
          </IconButton>
        </Box>
      </DialogTitle>
      <DialogContent>
        <Alert severity="success" sx={{ mb: 3 }}>
          Your form is now live and ready to share!
        </Alert>

        <Box sx={{ mb: 3 }}>
          <Typography variant="subtitle2" gutterBottom>Form link</Typography>
          <Box display="flex" gap={1}>
            <TextField
              fullWidth
              value={formLink}
              variant="outlined"
              size="small"
              InputProps={{ readOnly: true }}
            />
            <Button
              variant="contained"
              onClick={handleCopyLink}
              startIcon={copied ? <CheckIcon /> : <ContentCopyIcon />}
            >
              {copied ? 'Copied!' : 'Copy'}
            </Button>
          </Box>
        </Box>

        <Divider sx={{ my: 2 }} />

        <Typography variant="subtitle2" gutterBottom>Share via</Typography>
        <Grid container spacing={1}>
          <Grid item>
            <Tooltip title="Share on X">
              <IconButton color="primary" onClick={() => handleShare('twitter')}>
                <XIcon />
              </IconButton>
            </Tooltip>
          </Grid>
          <Grid item>
            <Tooltip title="Share on Facebook">
              <IconButton color="primary" onClick={() => handleShare('facebook')}>
                <FacebookIcon />
              </IconButton>
            </Tooltip>
          </Grid>
          <Grid item>
            <Tooltip title="Share on LinkedIn">
              <IconButton color="primary" onClick={() => handleShare('linkedin')}>
                <LinkedInIcon />
              </IconButton>
            </Tooltip>
          </Grid>
          <Grid item>
            <Tooltip title="Share via Email">
              <IconButton color="primary" onClick={() => handleShare('email')}>
                <EmailIcon />
              </IconButton>
            </Tooltip>
          </Grid>
        </Grid>
      </DialogContent>
    </Dialog>
  );
};

export default PublishModal;